import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportMemberVoucherPage } from './report-member-voucher.page';

const routes: Routes = [
  {
    path: '',
    component: ReportMemberVoucherPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportMemberVoucherPageRoutingModule {}
